
import Breadcrumbs from '~/components/UI/Breadcrumbs';

export default {
  name: 'CurrentNews',

  head() {
    const head = {
      title: this.news?.seo_title || this.news?.title,
      meta: [],
    };

    const description = this.news?.seo_description;
    if (description) {
      head.meta.push({ hid: 'metadescription', name: 'description', content: description });
      head.meta.push({
        name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
      });
    }

    return head;
  },

  data() {
    return {
      news: {},
      allNews: [],
      isLoad: true,
    };
  },

  computed: {
    getBreadcrumbs() {
      return [
        { path: '/', title: 'Главная' },
        {
          path: '/news',
          title: 'Новости',
        },
        { path: this.$route.path, title: this?.news?.title || '' },
      ];
    },

    filterAllNews() {
      return this.allNews.filter((t) => t.id !== this.news.id);
    },
  },

  components: {
    Breadcrumbs,

    NewsCardExtraSmall: () => import('~/components/news/NewsCardExtraSmall'),
  },

  async fetch() {
    await this.getNews();
    await this.getAllNews();
  },

  methods: {
    dateFrom(publishedAt) {
      const date = new Date(Number.parseFloat(publishedAt) * 1000).toLocaleDateString('ru', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      return `${date}`;
    },

    async getNews() {
      const slug = this.$route?.params?.slug || '';
      if (!slug) {
        this.$nuxt.error({
          statusCode: 404,
        });

        return;
      }

      const news = await this.$api.agent.transport.get(`/news/${slug}?expand=tags`).then((res) => res.data).catch(() => null);
      if (!news) {
        this.$nuxt.error({
          statusCode: 404,
        });

        return;
      }

      this.news = news;
    },

    async getAllNews() {
      const response = await this.$api.agent.transport
        .get('/news')
        .then((res) => res.data || [])
        .catch(() => ({}));

      this.allNews = response;
    },
  },
};

